module.exports = ['error', 'err', 'e', 'response', 'res', 'resp', 'Error', 'Response', 'errorObj', 'errObj', 'result'];
